import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useEnterSubmit } from './common'
import { Button } from '../ui/button'
import { Lock, Mail } from 'lucide-react'
import { AuthCard, AuthTextInput } from './auth_card'

export const LoginForm = ({ onSubmit, loading }) => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [remember] = useState(true)

    const submit = () => {
        if (onSubmit) {
            onSubmit(email, password, remember)
        }
    }

    const onEnter = useEnterSubmit(submit)
    return (
        <AuthCard
            title="Welcome back"
            subtitle={
                <>
                    Don't have an account yet?{' '}
                    <Link className="font-medium text-gray-600 hover:text-[#2d72d2]" to="/register">
                        Sign up
                    </Link>
                </>
            }
        >
            <AuthTextInput
                name="email"
                placeholder="Email address"
                disabled={loading}
                value={email}
                onChange={setEmail}
                onKeyDown={onEnter}
                icon={<Mail />}
            />

            <AuthTextInput
                name="password"
                type="password"
                placeholder="Password"
                disabled={loading}
                value={password}
                onChange={setPassword}
                onKeyDown={onEnter}
                icon={<Lock />}
            />

            <div className="flex flex-col items-center gap-3">
                <Button
                    loading={loading}
                    intent="primary"
                    type="submit"
                    text="Login"
                    fill
                    className="h-[37px]"
                    onClick={submit}
                />
                <Link className="text-xs text-gray-500 hover:text-gray-700" to="/password/forget">
                    Forgot your password?
                </Link>
            </div>
        </AuthCard>
    )
}
